import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzActionsMenuModule } from '@blk/daisy/combinations/actions-menu';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { DzRadioModule } from '@blk/daisy/elements/selection-controls';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DomModule } from '@ddt-web/dom';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';
import { faArrowDown, faArrowUp, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { FundStatusInteractionMenuComponent } from './components/fund-status-interaction-menu/fund-status-interaction-menu.component';
import { StatusByColorPipe } from './pipes/status-by-color.pipe';
import { StatusCellRendererComponent } from './renderers/status-cell.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		DzIconModule.withIcons(faArrowUp, faArrowDown, faPencilAlt),
		GenericDirectivesModule,
		DomModule,
		DzActionsMenuModule,
		DzIconModule.withIcons(faTimes),
		DzRadioModule,
		DzButtonModule,
		GenericDirectivesModule,
		AnalyticsModule
	],
	declarations: [
		StatusByColorPipe,
		StatusCellRendererComponent,
		FundStatusInteractionMenuComponent
	],
	exports: [
		StatusByColorPipe,
		StatusCellRendererComponent,
		FundStatusInteractionMenuComponent
	]
})
export class FundStatsModule { }
